var _circle, _circle2, _rect, _path, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 132,
    cy: 132,
    r: 132,
    fill: "url(#paint0_angular_1466_8978)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 132.471,
    cy: 132.471,
    r: 72.4706,
    fill: "url(#paint1_angular_1466_8978)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 103.5,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#31FFCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.375 129.897C121.375 124.147 126.18 119.5 131.992 119.5C137.82 119.5 142.625 124.147 142.625 129.897C142.625 132.795 141.571 135.485 139.837 137.764C137.924 140.279 135.565 142.471 132.911 144.191C132.303 144.588 131.755 144.618 131.088 144.191C128.418 142.471 126.06 140.279 124.163 137.764C122.427 135.485 121.375 132.795 121.375 129.897ZM128.493 130.222C128.493 132.148 130.065 133.663 131.992 133.663C133.92 133.663 135.507 132.148 135.507 130.222C135.507 128.31 133.92 126.722 131.992 126.722C130.065 126.722 128.493 128.31 128.493 130.222Z",
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 103.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1466_8978",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132 132) rotate(90) scale(132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31FFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFCD",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_1466_8978",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.471 132.471) rotate(90) scale(72.4706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31FFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31FFCD",
    stopOpacity: 0.17
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMarker);
export default __webpack_public_path__ + "static/media/new-marker.d98470387a4d46d181761f94808c1ab7.svg";
export { ForwardRef as ReactComponent };